import { Grid, withStyles } from '@material-ui/core';
import { memo } from 'react';
import { StyledRadioGroup } from '../../../Dispatch/RouteExecution/DriverPopUp/common/RadioGroup';
import Select from '../../../../common/StyledSelect';
import { APPOINTMENT_RADIO_OPTIONS, APPOINTMENT_TYPES } from '../constants';

const styles = (theme) => ({
  InputLabelProps: {
    color: theme.iconColor,
    transform: 'translate(14px, 13px) scale(1)'
  },
  selectFilterClass: {
    direction: 'column',
    marginRight: 8,
    marginTop: 8,
    width: '100px',
    '&>div': {
      flex: 1,
      width: '100%'
    }
  },
  huLabel: {
    marginTop: 8
  }
});

const getHURange = () => {
  return Array.from({ length: 30 }, (_, index) => ({
    label: `${index + 1}`,
    value: index + 1
  }));
};
const Appointment = ({
  classes,
  handleAppointmentChange,
  appointmentValue,
  minimumHUValue,
  handleMinHUChange,
  configJSON
}) => {
  const filteredAppointmentOptions = APPOINTMENT_RADIO_OPTIONS.filter(({ featureFlag }) => configJSON?.[featureFlag] === true);
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <span>
            If the freight bill appointment is already set below requirements will be ignored.
          </span>
        </Grid>
        <Grid item xs={12}>
          <StyledRadioGroup
            key={appointmentValue} // Key forces re-render; ensures null value resets selection
            onChange={handleAppointmentChange}
            options={filteredAppointmentOptions}
            value={appointmentValue}
          />
        </Grid>
        {appointmentValue === APPOINTMENT_TYPES.REQUIRES_APT && (
          <>
            <Grid item xs={12} className={classes.huLabel}>
              <span>Minimum HU required for appointment</span>
            </Grid>
            <Grid item>
              <Select
                textFieldProps={{
                  id: 'minHU',
                  label: 'HU',
                  variant: 'outlined'
                }}
                value={minimumHUValue}
                onChange={handleMinHUChange}
                data={getHURange()}
                InputLabelProps={{
                  classes: {
                    root: classes.InputLabelProps
                  }
                }}
                classes={{
                  root: classes.selectFilterClass
                }}
                menuPosition={'fixed'}
              />
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default withStyles(styles)(memo(Appointment));
